export const CATEGORIES = [
  { label: 'All Categories', value: '' },
  { label: 'Education', value: 'Education' },
  { label: 'Medical', value: 'Medical' },
  { label: 'Women & Girls', value: 'Women & Girls' },
  { label: 'Animals', value: 'Animals' },
  { label: 'Creative', value: 'Creative' },
  { label: 'Food & Hunger', value: 'Food & Hunger' },
  { label: 'Environment', value: 'Environment' },
  { label: 'Children', value: 'Children' },
  { label: 'Memorial', value: 'Memorial' },
  { label: 'Community Development', value: 'Community Development' },
  { label: 'Others', value: 'Others' }
];

export const LOCATIONS = [
  { label: 'All Locations', value: '' },
  { label: 'Mumbai', value: 'Mumbai' },
  { label: 'Bengaluru', value: 'Bengaluru' },
  { label: 'New Delhi', value: 'New Delhi' },
  { label: 'Hyderabad', value: 'Hyderabad' },
  { label: 'Chennai', value: 'Chennai' },
  { label: 'Delhi', value: 'Delhi' },
  { label: 'Pune', value: 'Pune' },
  { label: 'Kolkata', value: 'Kolkata' },
  { label: 'Ahmedabad', value: 'Ahmedabad' },
  { label: 'Jaipur', value: 'Jaipur' },
  { label: 'Lucknow', value: 'Lucknow' },
  { label: 'Gurugram', value: 'Gurugram' },
  { label: 'Chandigarh', value: 'Chandigarh' },
  { label: 'Noida', value: 'Noida' },
  { label: 'Kochi', value: 'Kochi' },
  { label: 'Others', value: 'Others' }
];


export const TAGS = [
  { label: 'All Types', value: '' },
  { label: 'Tax Benefit ', value: 'Tax Benefit' },
  { label: 'Trending', value: 'Trending' },
  { label: 'Urgently Funds Required', value: 'Urgent' },
  { label: 'Successfully Funded', value: 'Successfully Funded' }
];
